<template>
  <div>
    <a href="#main-content" class="skip-to-main">Skip to main content</a>
    <div class="wrap" v-if="!embed">
      <v-toolbar color="#005cb8" flat dense style="margin-bottom: -50px; height: 60px;" role="banner">
        <a href="https://arlingtonva.us" class="mx-2 pa-0" style="width: 220px; height: 60px; overflow: hidden;" aria-label="Arlington County Virginia home">
          <v-img class="my-auto" max-width="200" position="top, left" src="https://arlingtonva.s3.amazonaws.com/wp-content/CountyLogo_Reverse_Horizontal.png" alt="Arlington County Virginia"/>
        </a>
        <v-spacer/>
        <v-toolbar-items>
        </v-toolbar-items>
      </v-toolbar>
    </div>
    <v-app :class="{ embedded: embed }" id="main-content">
      <router-view />
    </v-app>
    <v-footer color="#005cb8" v-if="!embed" role="contentinfo">
      <p class="ma-auto white--text body-2">Copyright © {{new Date().getFullYear()}} Arlington County Virginia</p>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    embed () {
      return this.$route.query && this.$route.query.embed && this.$route.query.embed === 'true';
    }
  }
};
</script>

<style lang="scss">
$acg-blue: #005cbb;
$acg-light-blue: #2e8be8;
$acg-grey: #666;
$link-hover: #7ac4fc;

.skip-to-main {
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: 10000;
  padding: 12px 16px;
  background: #fff;
  color: #005cbb;
  font-weight: 700;
  text-decoration: underline;
}

.skip-to-main:focus {
  left: 16px;
  top: 16px;
  width: auto;
  height: auto;
  overflow: visible;
  outline: 3px solid #2e8be8;
  outline-offset: 2px;
}

/* Programmatic focus after route changes should not show a ring; keyboard (:focus-visible) still does */
#main-content:focus:not(:focus-visible) {
  outline: none;
}

#main-content:focus-visible {
  outline: 3px solid #2e8be8;
  outline-offset: 2px;
}

#app {
  background-color: white;
}

.vue-map {
  height: 560px;
  width: 100%;
}

.gm-style-iw {
  font-size: initial !important;
}

.gm-style .gm-style-iw {
  font-size: 100% !important;
}

input,
select {
  font-family: "Open Sans", arial, sans-serif;
}

//html5 roles
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
main {
  display: block;
}

p {
  font-size: 1.3em;
  line-height: 1.5;
}

.list-item {
  margin-top: 4px;
  margin-bottom: 8px;
  border-bottom: 1px solid #ccc;
}

.menu {
  margin-top: 40px;
}

.widget {
  max-height: 640px;
  overflow-y: scroll;
  display: inline-flex;
  flex-flow: column;
  margin: 0;
  flex-grow: 1;

  ul {
    padding: 0;
    list-style: none;
  }

  h4,
  h5,
  h6 {
    color: $acg-grey;
  }
}

.half {
  width: 480px;
}

.one-third {
  max-width: 300px;
  flex-grow: 100;
  margin: 0;
  padding: 0 8px 8px 12px;
}

.two-thirds {
  width: 600;
  margin: 0;
  padding: 8px 8px 8px 12px;
}

.page {
  min-height: 600px;
  margin-top: 78px;
}

.site-inner {
  max-width: 1280px;
}

main ul,
.sub-menu ul {
  padding: 0;
}

main ul li {
  list-style-type: none;
  font-size: 1.5em;
}

.widget li,
.widget p {
  font-size: 1.5em;
}

.sub-menu h4 {
  margin: 0 0 1px;
}
.sub-menu ul li {
  list-style-type: none;
  font-size: 1.25em;
  line-height: 1.5;
}

//From all.css

.layer-page {
  max-width: 1280px;
  margin: 0 auto 20px;
  padding-top: 16px;
  display: flex;
}

.holder {
  max-width: 1280px;
}

.filter-pane {
  max-height: 640px;
  overflow-y: scroll;
  box-sizing: border-box;
}

.full-map-pane {
  padding: 8px 0;
  height: 632px;
  box-sizing: border-box;
  flex-grow: 100;
  overflow-y: hidden;
}

.layer-label {
  margin-left: 2px;
}

li .circle {
  margin-left: 4px;
}

.circle {
  cursor: pointer;
  border-radius: 50%;
  display: inline-block;
}

.info-window {
  font-size: larger !important;
}

h3 {
  color: black;
  margin: 0.3em 0 0.2em;
}

.filter-container {
  margin-bottom: 16px;
}

.filter-header {
  cursor: pointer;
  background-color: #fff;
  background: linear-gradient(#fff, #eee);
  color: $acg-grey;
  font-weight: bold;
  vertical-align: middle;
  border: 0.5px solid #ddd;
  font-size: 1.5em;
  padding: 4px 8px;
  border-radius: 4px;
}

.filter-item,
.filter-item > span {
  padding-top: 4px;
  background-color: #fff;
  color: #000;
  font-weight: normal;
  font-size: 1.3em;
  line-height: 1.5;
}

.sub-filter-item {
  margin-left: 16px;
  font-size: 100%;
}

.filter-container label {
  font-size: 1.45em;
  font-weight: bold;
  color: $acg-grey;
  margin-top: 4px;
}

.filter-container input[type="text"],
.filter-container select {
  box-sizing: border-box;
  width: 100%;
  padding: 6px 8px;
  margin-top: 2px;
  font-size: 1.45em;
  //color: #666;
}

.zoom-container input[type="text"] {
  border-radius: 4px;
  border: 0.5px solid #ddd;
}

.filter-container select {
  //-webkit-appearance: none;
  //-moz-appearance: none;
  //appearance: none;
  background-color: #fff;
  border: 0.5px solid #ddd;
}

.v-text-field--box > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 24px !important;
  display: flex !important;
  align-items: center !important;
}

.v-text-field.v-text-field--enclosed .v-input__append-inner,
.v-text-field.v-text-field--enclosed .v-input__append-outer,
.v-text-field.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field.v-text-field--enclosed .v-input__prepend-outer {
  margin-top: 6px !important;
}

.theme--light.v-select .v-select__selections {
  padding-top: 2px !important;
  padding-left: 6px !important;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 0.5px solid #ddd !important;
  border-radius: 4px !important;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0px !important;
  margin: 0px !important;
}

.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  color: $acg-grey;
  fill: $acg-grey;
  stroke: $acg-grey;
  height: 15px;
  width: 15px;
}

.loader-img {
  position: relative;
  bottom: 311px;
  z-index: 10;
  left: 370px;
}

#mobile-menu {
  margin-bottom: 16px;
  font-size: 1.5em;
}

#page-header {
  margin: 78px 8px 0;
  font-size: 4em;
}

#blurb {
  margin-top: 8px;
  margin-left: 8px;
  font-size: 100%;
}

#blurb p {
  font-size: 1rem;
}

#mobile-menu,
#filters-and-settings {
  flex: 0 0 auto;
}

.link {
  color: $acg-blue;
  cursor: pointer;
}

.link:hover {
  color: $link-hover;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 240px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  top: 135%;
  left: 20px;
  margin-left: -40px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 1s;
}

.tooltip .tooltiptext > a {
  color: #fff;
  text-decoration: underline;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #555;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

@media (max-width: 960px) {
  .filter-pane {
    width: 260px;
    max-width: 260px;
  }
}

@media (max-width: 720px) {
  .filter-pane {
    width: 220px;
    max-width: 220px;
  }
}

@media (max-width: 600px) {
  .layer-page {
    width: 100%;
    display: block;
  }

  .widget {
    display: block;
  }

  .full-map-pane {
    box-sizing: border-box;
  }

  .filter-pane {
    width: 100%;
    max-width: initial;
  }

  .filter-header,
  .filter-header span {
    text-align: left;
    width: 100%;
    box-sizing: border-box;
  }

  .filter-header span {
    padding: 8px;
  }

  .layer-page {
    border-left: none;
    border-right: none;
    border-bottom: none;
    border-radius: 0;
  }

  .loader-img {
    margin: 0 auto;
    display: block;
    left: 0;
  }

  .info-window {
    font-size: 100%;
  }
}

#header {
  background-color: $acg-light-blue;
  height: 50px;
  padding-top: 8px;
  width: 100%;
  position: fixed;
  z-index: 3;
  margin-bottom: 78px;
  top: 0;

  a.logo:visited {
    color: #fff;
  }

  .logo {
    font-size: 2.5em;
    font-family: "PT Sans", sans-serif;
    text-decoration: none;
    display: inline-block;
    padding-top: 4px;
    color: #fff;
    margin-right: 8px;
  }

  .logo i {
    font-size: 150%;
    vertical-align: text-top;
  }
}

#top-logo {
  display: inline-block;
}

#top-links {
  margin-top: 14px;
  font-size: 1.5em;
  float: right;
  min-height: 0;
}

#top-links p {
  margin: 0;
  padding: 0;
}

@media (max-width: 780px) {
  nav {
    background-color: #fff;
  }
}

@media (max-width: 650px) {
  #header {
    position: static;
    padding: 0 8px 8px;
    box-sizing: border-box;
    height: auto;
    margin-bottom: 0;
  }

  #page-header {
    margin-top: 12px;
  }

  #top-links {
    padding: 0;
    margin-top: -8px;
    display: block;
    float: none;
    text-align: center;
  }

  #top-links p a:first-of-type,
  #top-links p b:first-of-type {
    display: inline;
  }

  .tab-bar {
    margin-top: 28px;
  }
}

.embedded {
  .holder {
    display: none;
  }
}

.toggle-link {
  color: #015cb9;
  text-decoration: underline;
}

.toggle-link.active {
  color: #00376e;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?aebd1a48